import {
  ButtonPrimary,
  ButtonPseudo,
  // ButtonSecondary,
} from '@ui/src';
import { ConfirmPopupTypes } from './types';

import cn from './styles.module.css';

const ConfirmPopup = ({
  // usersWithCustomPerms,
  // usersWithDefaultPerms,
  onSubmit,
  onCancel,
  isLoading,
  globalError,
  editIsLoading,
  text,
}: ConfirmPopupTypes): React.JSX.Element => (
  <div className={cn.confirmPopup}>
    <div className={cn.confirmPopupTitle}>Save changes for:</div>
    <div className={cn.confirmPopupButtons}>
      <ButtonPrimary
        bold
        text={
          editIsLoading ? 'Loading...' : text || 'For all users with this Role'
        }
        disabled={isLoading || editIsLoading}
        onClick={onSubmit}
      />
      {/* <ButtonPrimary
        bold
        text={`For all users with this Role (${usersWithCustomPerms})`}
        disabled={isLoading}
        onClick={onSubmit}
      /> */}
      {/* <ButtonSecondary
        bold
        text={`For users with default role settings (${usersWithDefaultPerms})`}
        disabled={isLoading}
        onClick={onSubmit}
      /> */}
      {globalError && <div className={cn.globalError}>{globalError}</div>}

      <ButtonPseudo
        bold
        text="Cancel"
        className="button-white"
        onClick={onCancel}
      />
    </div>
  </div>
);

export default ConfirmPopup;
